import { Bold, Flex } from './TremorCompat';
import { Panel, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';

export const DisplayTextItem = ({ theText, tc, theTitle, icon, onClick, borderOff }) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="space-y-0.5">
          <Text color={tc}>{theTitle}</Text>
          <Text color={tc}>
            <Bold>{theText}</Bold>
          </Text>
        </div>
      </Flex>
    </Panel>
  );
};
